import { Component, type ErrorInfo, type ReactNode } from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorState } from '@/components/ErrorState';

interface Props {
  children: ReactNode;
  /** この値が変わるとエラー状態をリセット（画面遷移で復帰） */
  resetKey?: string;
}
interface State {
  error: unknown;
  key?: string;
}

/** 画面描画中の例外を捕捉し、レイアウトを残したままエラー表示する */
export class RouteErrorBoundary extends Component<Props, State> {
  override state: State = { error: null, key: this.props.resetKey };

  static getDerivedStateFromError(error: unknown): Partial<State> {
    return { error };
  }

  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    if (props.resetKey !== state.key) return { error: null, key: props.resetKey };
    return null;
  }

  override componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error('画面でエラーが発生しました', error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <ErrorState
          title="画面の表示中にエラーが発生しました"
          error={this.state.error}
          onRetry={() => this.setState({ error: null })}
        />
      );
    }
    return this.props.children;
  }
}

/** data router の errorElement 用 */
export function RouterErrorPage() {
  const error = useRouteError();
  return (
    <div style={{ padding: 48 }}>
      <ErrorState title="画面を表示できませんでした" error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}
